import { z } from "zod";

const isoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, "expected YYYY-MM-DD");

export const stopSaleDtoSchema = z.object({
  id: z.string().uuid(),
  activityId: z.string().uuid(),
  activityName: z.string().nullable(),
  activitySlug: z.string().nullable(),
  /** City and category of the activity, for the admin calendar's filters and colours. */
  cityName: z.string().nullable().optional(),
  citySlug: z.string().nullable().optional(),
  categoryName: z.string().nullable().optional(),
  categorySlug: z.string().nullable().optional(),
  categoryTemplate: z.string().nullable().optional(),
  packageId: z.string().uuid().nullable(),
  packageName: z.string().nullable(),
  fromDate: isoDate,
  toDate: isoDate,
  reason: z.string().nullable(),
  createdBy: z.string().uuid().nullable(),
  createdByName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type StopSaleDTO = z.infer<typeof stopSaleDtoSchema>;

export const stopSaleCreateSchema = z
  .object({
    activityId: z.string().uuid(),
    packageId: z.string().uuid().nullable().optional(),
    fromDate: isoDate,
    toDate: isoDate,
    reason: z.string().max(500).optional().nullable(),
  })
  .refine((v) => v.toDate >= v.fromDate, {
    message: "toDate must be on or after fromDate",
    path: ["toDate"],
  });
export type StopSaleCreateInput = z.infer<typeof stopSaleCreateSchema>;

export const stopSaleUpdateSchema = z
  .object({
    packageId: z.string().uuid().nullable().optional(),
    fromDate: isoDate.optional(),
    toDate: isoDate.optional(),
    reason: z.string().max(500).nullable().optional(),
  })
  .refine((v) => !v.fromDate || !v.toDate || v.toDate >= v.fromDate, {
    message: "toDate must be on or after fromDate",
    path: ["toDate"],
  });
export type StopSaleUpdateInput = z.infer<typeof stopSaleUpdateSchema>;

export const stopSaleListQuerySchema = z.object({
  activityId: z.string().uuid().optional(),
  from: isoDate.optional(),
  to: isoDate.optional(),
  active: z.enum(["true", "false"]).optional(),
});
export type StopSaleListQuery = z.infer<typeof stopSaleListQuerySchema>;
